import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e9282c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "outer-border" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner-border" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "gi-primo-star dull" }),
    /*#__PURE__*/_createElementVNode("i", { class: "gi-companion duller" })
  ])
], -1))
const _hoisted_2 = { class: "img-container" }
const _hoisted_3 = ["src"]

import { HeaderTransforms } from "@/state/Gacha";
import { Banner } from "@/types";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    banner: null,
    isSelected: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props as { banner: Banner, isSelected: boolean }

_useCssVars(_ctx => ({
  "3c7bd7c1": (scale),
  "50cebb22": (x),
  "50cebb20": (y)
}))

const DEFAULT_BANNER_ICON_CHAR = "qiqi";



// take first featured char
const iconChar =
  props.banner.headerCharacter ??
  props.banner.featuredDrops[0] ??
  DEFAULT_BANNER_ICON_CHAR;

const transforms = HeaderTransforms[iconChar];
const x = `${transforms?.x ?? 0}%`;
const y = `${transforms?.y ?? 0}%`;
const scale = `${transforms?.scale ?? 100}%`;

const iconCharSrc = computed(() => {
  const images = require.context(
    "@/assets/images/banner-headers/",
    false,
    /\.webp$/
  );
  try {
    return images(`./${iconChar}.webp`);
  } catch (error) {
    return `./${iconChar}.webp`;
  }
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['button', { selected: __props.isSelected }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", { src: _unref(iconCharSrc) }, null, 8, _hoisted_3)
    ])
  ], 2))
}
}

})